module.exports = __webpack_public_path__ + "img/android_n.372077ef.png";